import getLocale from 'browser-locale';
import Cookies from 'js-cookie';
import {
	CURRENT_LANGUAGE
} from '../actions/current-language';

const locale = getLocale().split('-')[0]; // Gets the locale code based on the browser configuration
const INITIAL_STATE = Cookies.get('language') !== undefined ? Cookies.get('language') : Cookies.set('language', locale, { expires: 365 });

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case CURRENT_LANGUAGE:// return list of posts and make loading = false
            return { ...state, data: action.payload, error: null };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer-current-language.js